import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {ErrorPresenter} from '../error-presenter';

export const GenericError: FC = () => {
  const {t} = useTranslation('common', {keyPrefix: 'components.generic-error'});

  return (
    <ErrorPresenter data-testid="generic-error" title={t('title')}>
      <p>{t('message-line1')}</p>
      <p>{t('message-line2')}</p>
    </ErrorPresenter>
  );
};
